export enum SOURCE {
    HPL = 'AG_HPL',
    VIETJET = 'D_VIETJET',
    TBO = 'AG_TBO', 
}

export enum AGENCY_NAME {
    VIETJET = 'vietjet',
    TBO = 'tbo',
    HPL = 'hpl', 
    FL_REVENUE = 'fl-revenue'
}